import { render } from "./SidebarMenu1.vue?vue&type=template&id=f4322c46&scoped=true"
import script from "./SidebarMenu1.vue?vue&type=script&lang=js"
export * from "./SidebarMenu1.vue?vue&type=script&lang=js"

import "./SidebarMenu1.vue?vue&type=style&index=0&id=f4322c46&lang=scss&scoped=true"

import exportComponent from "../../../../../SINTEZ/OKCU/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4322c46"]])

export default __exports__